// extracted by mini-css-extract-plugin
export default {"cardContainer":"Showcase-module--cardContainer--zz2vp","cardItem":"Showcase-module--cardItem--OQLO1","visibleIndicator":"Showcase-module--visibleIndicator--1SAhh"};